<template>
  <b-container id="forgot-page">
    <div class="text-center">
      <img src="../assets/UCT_logo.png" width="300" alt="UCT logo">
    </div>
    <div class="text-center mt-5 mb-3">
      <img src="../assets/IoT-Let.png" width="250" alt="IoT-Let">
    </div>
    <div id="forgot-pwd" class="form-group col-lg-12 text-center mt-5">
      <h4  for="input-email">Forgot Password</h4>
      <input type="text" id="input-email" class="form-control" style="height:50px" name="email" placeholder="Enter email address" v-model="email"/>
      <button type="button" class="btn btn-lg btn-primary btn-block mt-3 mb-3" v-on:click="onReset()">Reset Password</button>
      <a href="/login">Login</a>
    </div>
    <h5 class="error_message text-center mt-3">{{msg}}</h5>

    <!-- Reset Password Modal -->

    <b-modal id="reset_code_modal" title="Reset Code" :no-close-on-backdrop="true" :hide-header-close="true">
      <div id="reset-code" class="form-group text-left mt-1">
        <h5 >1. To get reset code, please click here</h5>
        <button type="button" class="btn btn-lg btn-secondary ml-5 mt-3 mb-3" v-on:click="onSendCode()">SEND RESET CODE</button>
        <h5 >2. Fill the received code and your new password </h5>
        <input type="text" id="input-reset-code" class="form-control mt-3" style="height:50px" placeholder="Reset Code" v-model="resetCode"/>
        <input type="password" id="input-new-pwd" class="form-control mt-3" style="height:50px" placeholder="New Password" v-model="newPWD"/>
        <input type="password" id="input-verify" class="form-control mt-3 mb-3" style="height:50px" placeholder="Verify Password" v-model="verifyPWD"/>
        <p>
          Your password must contain at least: <br>
           - One lower case letter <br>
           - One upper case letter <br>
           - Minimum 8 characters <br>
           - One number <br>
        </p>
        <h5 class="error_message">{{modalErrMsg}}</h5>
        <h5 class="success_message">{{modalSuccessMsg}}</h5>
      </div>
      <template #modal-footer>
        <b-button size="lg" variant="secondary" class="mr-auto" @click="Close()">
          CLOSE
        </b-button>

        <b-button size="lg" variant="outline-success" class="justify-content-center" @click="SavePWD()">
          SAVE
        </b-button>
      </template>
    </b-modal>


  </b-container>
</template>

<script>
import restAPI from '@/global/rest_api'

export default {
  name: 'Forgot',
  data () {
    return {
      msg: '',
      email: '',
      resetCode: '',
      newPWD: '',
      verifyPWD: '',
      modalErrMsg: '',
      modalSuccessMsg: ''
    }
  },
  methods: {
    async onReset () {
      this.msg = ''
      try {
        if (this.email === '' || this.email.length < 3 || !(/@/.test(this.email)) ) {
          this.msg = '❌ Please enter valid email address'
          return
        }
        await restAPI.auth.checkUser({email: this.email})
        this.$bvModal.show('reset_code_modal')
      } catch (err) {
        console.log(err)
        this.msg = '❌ Email address is invalid! Please try again.'
        this.$bvModal.hide('reset_code_modal')
      }
    },
    async onSendCode () {
      this.modalErrMsg = ''
      this.modalSuccessMsg = ''
      try {
        await restAPI.auth.fortgetPassword({email: this.email})
        this.modalErrMsg = ''
        this.modalSuccessMsg = ' ✅ Request Sent Success'
      } catch (err) {
        this.modalSuccessMsg = ''
        this.modalErrMsg = '❌ Request Failed'
        console.log(err)
      }
    },
    validatePWD () {
      if (this.resetCode === '' || this.newPWD === '' || this.verifyPWD === '') {
        this.modalErrMsg = '❌ Please fill in all field'
        return false
      }
      if (this.newPWD !== this.verifyPWD) {
        this.modalErrMsg = '❌ Please make sure your passwords match'
        return false
      }
      if (!(/[a-z]/.test(this.newPWD)) || !(/[A-Z]/.test(this.newPWD)) || !(/[0-9]/.test(this.newPWD)) || this.newPWD.length < 8 ) {
        this.modalErrMsg = '❌ Please enter valid password'
        return false
      }
      return true
    },
    clear() {
      this.msg = ''
      this.email = ''
      this.resetCode = ''
      this.newPWD = ''
      this.verifyPWD = ''
      this.modalErrMsg = ''
      this.modalSuccessMsg = ''
    },
    Close () {
      this.clear()
      this.$bvModal.hide('reset_code_modal')
    },
    async SavePWD () {
      this.modalErrMsg = ''
      this.modalSuccessMsg = ''
      if (!this.validatePWD()) {
        return
      }
      try {
        let payload = {
          email: this.email,
          reset_code: this.resetCode,
          new_password: this.newPWD,
          verify_password: this.verifyPWD,
          time: new Date().toString()
        }
        console.log(payload)
        await restAPI.auth.resetPassword(payload)
        this.modalErrMsg = ''
        this.modalSuccessMsg = ' ✅ Save New Password Success'
      } catch (err) {
        this.modalSuccessMsg = ''
        this.modalErrMsg = '❌ Save New Password Failed'
        console.log(err)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #forgot-page {
    padding: 50px;
    width: 500px;
    height: 100vh;
    margin: auto;
  }
  a {font-size: 20px}
  p {color: blue}
  .error_message {
    color: red
  }
</style>
